import { BrowserRouter, Routes } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { CookieConsentComponent } from "@/app/components/CookieConsent";
import { AttributionStamper } from "@/app/components/AttributionStamper";
import { ContextualOverlayProvider } from "@/app/components/ContextualOverlay";
import { LoadingSpinner } from "@/shared/components/ui/loading-spinner";
import { initializePaddle } from "@/app/lib/paddle";
import { FEATURES } from "@/shared/config";
import { renderAppRoutes } from "@/routes";

// Umami SPA route tracking is handled by the cloud script itself: it patches
// history.pushState / replaceState and emits a pageview on every navigation.
// No explicit hook needed.

function AppContent() {
  useEffect(() => {
    // PK-267: the ChatGPT preview page carries no checkout, so it doesn't
    // load Paddle.js. openUpgradeCheckout initializes on demand elsewhere.
    if (!FEATURES.enableBilling || window.location.pathname.startsWith("/preview/")) {
      return;
    }

    initializePaddle().catch((error) => {
      console.error("Failed to initialize Paddle", error);
    });
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {renderAppRoutes()}
        </Routes>
      </Suspense>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ContextualOverlayProvider>
        <CookieConsentComponent />
        <AttributionStamper />
        <AppContent />
      </ContextualOverlayProvider>
    </BrowserRouter>
  );
}

export default App;
